import customerRecharge from '../CustomerRecharge/CustomerRechargeStore';
import customerConsumption from '../CustomerConsumption/CustomerConsumptionStore';
import initFiltersStore from '@/store/modules/filters';

const initFilters = () => ({
  operateId: undefined,
  areaId: [],
  timeType: 0, // 0 本日，1 本月， 2 本年
});
const filtersStore = initFiltersStore(initFilters);

export default {
  namespaced: true,
  modules: { filtersStore, customerRecharge, customerConsumption },
};
